import { Module } from '@nestjs/common';
import { PrismaModule } from 'src/prisma/prisma.module';
import { AiUsageModule } from 'src/ai-usage/ai-usage.module';
import { AyudaConfigService } from './services/ayuda-config.service';
import { AyudaIaService } from './services/ayuda-ia.service';
import { AyudaProviderService } from './services/ayuda-provider.service';
import { AyudaIngestaService } from './services/ayuda-ingesta.service';
import { RerankerService } from './services/reranker.service';
import { AyudaConfigController } from './controllers/ayuda-config.controller';
import { AyudaIaController } from './controllers/ayuda-ia.controller';

@Module({
  imports: [PrismaModule, AiUsageModule],
  controllers: [AyudaConfigController, AyudaIaController],
  providers: [AyudaProviderService, AyudaConfigService, AyudaIaService, AyudaIngestaService, RerankerService],
  exports: [AyudaIaService, AyudaConfigService, AyudaProviderService],
})
export class AyudaIaModule {}
